export default __webpack_public_path__ + "static/image1-29e520db34cf1af837b3ed8e5e243c46.jpeg";